import { useEffect, useState } from "react";
import { TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert, Divider, Chip, MenuItem, Grid, Paper } from "@mui/material";
import { Countries, ProductStatus } from "../../../utils/Lookup";

import axios from "axios";
import Swal from "sweetalert2";

export default function EditProductForm({ open, handleClose, rowData, fetchData }) {
  const [editData, setEditData] = useState({});

  const [errors, setErrors] = useState({
    product_name: false,
    product_price: false,
    cash_drawer_price: false,
    receipt_printer_price: false,
    popcorn_contract_3m_price: false,
    popcorn_contract_6m_price: false,
    popcorn_contract_12m_price: false,
    rocket_membership_6m_price: false,
    rocket_membership_12m_price: false,
    implementation_online_price: false,
    implementation_onsite_price: false,
    admin_fee_price: false,
    country_id: false,
    order_no: false
  });
  const [helperText, setHelperText] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  const [imageHardwareLoaded, setImageHardwareLoaded] = useState(false);

  const handleImageHardwareLoad = () => {
    setImageHardwareLoaded(true);
  };

  const handleRemoveImageHardwareClick = () => {
    setImageHardwareLoaded(false);
    setEditData({ ...editData, product_image: "" });
  };

  const [imageCashDrawerLoaded, setImageCashDrawerLoaded] = useState(false);

  const handleImageCashDrawerLoad = () => {
    setImageCashDrawerLoaded(true);
  };

  const handleRemoveImageCashDrawerClick = () => {
    setImageCashDrawerLoaded(false);
    setEditData({ ...editData, cash_drawer_image: "" });
  };

  const [imageReceiptPrinterLoaded, setImageReceiptPrinterLoaded] = useState(false);

  const handleImageReceiptPrinterLoad = () => {
    setImageReceiptPrinterLoaded(true);
  };

  const handleRemoveImageReceiptPrinterClick = () => {
    setImageReceiptPrinterLoaded(false);
    setEditData({ ...editData, receipt_printer_image: "" });
  };

  useEffect(() => {
    if (rowData) {
      setEditData(rowData);
    }
    if (open) {
      setErrors({
        product_name: false,
        product_price: false,
        cash_drawer_price: false,
        receipt_printer_price: false,
        popcorn_contract_3m_price: false,
        popcorn_contract_6m_price: false,
        popcorn_contract_12m_price: false,
        rocket_membership_6m_price: false,
        rocket_membership_12m_price: false,
        implementation_online_price: false,
        implementation_onsite_price: false,
        admin_fee_price: false,
        country_id: false,
        order_no: false
      });
      setHelperText({});
      setErrorMessage("");
    }
  }, [rowData, open]);

  if (!rowData) return null;

  const setError = async (field, message) => {
    await setErrors((prevErrors) => ({ ...prevErrors, [field]: true }));
    await setHelperText((prevHelperText) => ({ ...prevHelperText, [field]: message }));
  };

  const validate = async (field, value) => {
    if (field === "product_name" && value === "") {
      await setError("product_name", "Name is required.");
    } else if (field === "product_price" && value === "") {
      await setError("product_price", "Hardware Price is required.");
    } else if (field === "cash_drawer_price" && value === "") {
      await setError("cash_drawer_price", "Cash Drawer Price is required.");
    } else if (field === "receipt_printer_price" && value === "") {
      await setError("receipt_printer_price", "Receipt Printer Price is required.");
    } else if (field === "popcorn_contract_3m_price" && value === "") {
      await setError("popcorn_contract_3m_price", "Popcorn Cashier 3 Months Price is required.");
    } else if (field === "popcorn_contract_6m_price" && value === "") {
      await setError("popcorn_contract_6m_price", "Popcorn Cashier 6 Months Price is required.");
    } else if (field === "popcorn_contract_12m_price" && value === "") {
      await setError("popcorn_contract_12m_price", "Popcorn Cashier 12 Months Price is required.");
    } else if (field === "rocket_membership_6m_price" && value === "") {
      await setError("rocket_membership_6m_price", "Rocket Membership 6 Months Price is required.");
    } else if (field === "rocket_membership_12m_price" && value === "") {
      await setError("rocket_membership_12m_price", "Rocket Membership 12 Months Price is required.");
    } else if (field === "implementation_online_price" && value === "") {
      await setError("implementation_online_price", "Implementation Online Price is required.");
    } else if (field === "implementation_onsite_price" && value === "") {
      await setError("implementation_onsite_price", "Implementation Onsite Price is required.");
    } else if (field === "admin_fee_price" && value === "") {
      await setError("admin_fee_price", "Admin Fee Price is required.");
    } else if (field === "country_id" && value === "") {
      await setError("country_id", "Manage By is required.");
    } else if (field === "order_no" && value === "") {
      await setError("order_no", "Order No is required.");
    } else if (field === "is_active" && value === "") {
      await setError("is_active", "Is Active is required.");
    } else {
      await setErrors((prevErrors) => ({ ...prevErrors, [field]: false }));
      await setHelperText((prevHelperText) => ({ ...prevHelperText, [field]: "" }));
    }
  };

  const handleEditProduct = async () => {
    try {
      const {
        product_name,
        product_price,
        product_image,
        cash_drawer_price,
        cash_drawer_image,
        receipt_printer_price,
        receipt_printer_image,
        popcorn_contract_3m_price,
        popcorn_contract_6m_price,
        popcorn_contract_12m_price,
        rocket_membership_6m_price,
        rocket_membership_12m_price,
        implementation_online_price,
        implementation_onsite_price,
        admin_fee_price,
        country_id,
        order_no,
        product_description,
        cash_drawer_description,
        receipt_printer_description,
        is_active,
      } = editData;

      const formData = new FormData();
      formData.append("product_name", product_name);
      formData.append("product_price", product_price);
      formData.append("cash_drawer_price", cash_drawer_price);
      formData.append("receipt_printer_price", receipt_printer_price);
      formData.append("popcorn_contract_3m_price", popcorn_contract_3m_price);
      formData.append("popcorn_contract_6m_price", popcorn_contract_6m_price);
      formData.append("popcorn_contract_12m_price", popcorn_contract_12m_price);
      formData.append("rocket_membership_6m_price", rocket_membership_6m_price);
      formData.append("rocket_membership_12m_price", rocket_membership_12m_price);
      formData.append("implementation_online_price", implementation_online_price);
      formData.append("implementation_onsite_price", implementation_onsite_price);
      formData.append("admin_fee_price", admin_fee_price);
      formData.append("country_id", country_id);
      formData.append("product_description", product_description);
      formData.append("cash_drawer_description", cash_drawer_description);
      formData.append("receipt_printer_description", receipt_printer_description);
      formData.append("product_image", product_image);
      formData.append("cash_drawer_image", cash_drawer_image);
      formData.append("receipt_printer_image", receipt_printer_image);
      formData.append("is_active", is_active);
      formData.append("order_no", order_no);

      const response = await axios.patch(process.env.REACT_APP_WEBSITE_BACKEND_URL + `api/v1/products/${rowData.product_id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        handleClose();
        Swal.fire({
          title: "Success",
          text: "Product information updated successfully",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });
        fetchData();
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage("An error occurred while updating the product information. Please try again later.");
      }
    }
  };

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Edit Product Information</DialogTitle>
      {errorMessage && (
        <Alert variant="outlined" severity="error" style={{ marginLeft: "24px", marginRight: "24px" }}>
          {errorMessage}
        </Alert>
      )}
      <DialogContent style={{ paddingBottom: "0px" }}>
        <Divider style={{ paddingTop: "0px", paddingBottom: "4px" }}>
          <Chip label="Product Details" />
        </Divider>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="product_name"
              label="Name"
              type="text"
              fullWidth
              required
              defaultValue={rowData.product_name}
              error={errors.product_name}
              helperText={helperText.product_name}
              onChange={(e) => {
                setEditData({ ...editData, product_name: e.target.value });
                validate("product_name", e.target.value);
              }}
            />
          </Grid>
        </Grid>
        <Divider style={{ paddingTop: "8px", paddingBottom: "4px" }}>
          <Chip label="Price Details" />
        </Divider>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="product_price"
              label="Hardware"
              type="number"
              fullWidth
              required
              defaultValue={rowData.product_price}
              error={errors.product_price}
              helperText={helperText.product_price}
              onChange={(e) => {
                setEditData({ ...editData, product_price: e.target.value });
                validate("product_price", e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="cash_drawer_price"
              label="Cash_Drawer"
              type="number"
              fullWidth
              required
              defaultValue={rowData.cash_drawer_price}
              error={errors.cash_drawer_price}
              helperText={helperText.cash_drawer_price}
              onChange={(e) => {
                setEditData({ ...editData, cash_drawer_price: e.target.value });
                validate("cash_drawer_price", e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="receipt_printer_price"
              label="Receipt Printer"
              type="number"
              fullWidth
              required
              defaultValue={rowData.receipt_printer_price}
              error={errors.receipt_printer_price}
              helperText={helperText.receipt_printer_price}
              onChange={(e) => {
                setEditData({ ...editData, receipt_printer_price: e.target.value });
                validate("receipt_printer_price", e.target.value);
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="popcorn_contract_3m_price"
              label="Popcorn Cashier 3 Months"
              type="number"
              fullWidth
              required
              defaultValue={rowData.popcorn_contract_3m_price}
              error={errors.popcorn_contract_3m_price}
              helperText={helperText.popcorn_contract_3m_price}
              onChange={(e) => {
                setEditData({ ...editData, popcorn_contract_3m_price: e.target.value });
                validate("popcorn_contract_3m_price", e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="popcorn_contract_6m_price"
              label="Popcorn Cashier 6 Months"
              type="number"
              fullWidth
              required
              defaultValue={rowData.popcorn_contract_6m_price}
              error={errors.popcorn_contract_6m_price}
              helperText={helperText.popcorn_contract_6m_price}
              onChange={(e) => {
                setEditData({ ...editData, popcorn_contract_6m_price: e.target.value });
                validate("popcorn_contract_6m_price", e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="popcorn_contract_12m_price"
              label="Popcorn Cashier 12 Months"
              type="number"
              fullWidth
              required
              defaultValue={rowData.popcorn_contract_12m_price}
              error={errors.popcorn_contract_12m_price}
              helperText={helperText.popcorn_contract_12m_price}
              onChange={(e) => {
                setEditData({ ...editData, popcorn_contract_12m_price: e.target.value });
                validate("popcorn_contract_12m_price", e.target.value);
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="rocket_membership_6m_price"
              label="Rocket Membership 6 Months"
              type="number"
              fullWidth
              required
              defaultValue={rowData.rocket_membership_6m_price}
              error={errors.rocket_membership_6m_price}
              helperText={helperText.rocket_membership_6m_price}
              onChange={(e) => {
                setEditData({ ...editData, rocket_membership_6m_price: e.target.value });
                validate("rocket_membership_6m_price", e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="rocket_membership_12m_price"
              label="Rocket Membership 12 Months"
              type="number"
              fullWidth
              required
              defaultValue={rowData.rocket_membership_12m_price}
              error={errors.rocket_membership_12m_price}
              helperText={helperText.rocket_membership_12m_price}
              onChange={(e) => {
                setEditData({ ...editData, rocket_membership_12m_price: e.target.value });
                validate("rocket_membership_12m_price", e.target.value);
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="implementation_online_price"
              label="Implementation Online"
              type="number"
              fullWidth
              required
              defaultValue={rowData.implementation_online_price}
              error={errors.implementation_online_price}
              helperText={helperText.implementation_online_price}
              onChange={(e) => {
                setEditData({ ...editData, implementation_online_price: e.target.value });
                validate("implementation_online_price", e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="implementation_onsite_price"
              label="Implementation Onsite"
              type="number"
              fullWidth
              required
              defaultValue={rowData.implementation_onsite_price}
              error={errors.implementation_onsite_price}
              helperText={helperText.implementation_onsite_price}
              onChange={(e) => {
                setEditData({ ...editData, implementation_onsite_price: e.target.value });
                validate("implementation_onsite_price", e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="admin_fee_price"
              label="Admin Fee (%)"
              type="number"
              fullWidth
              required
              defaultValue={rowData.admin_fee_price}
              error={errors.admin_fee_price}
              helperText={helperText.admin_fee_price}
              onChange={(e) => {
                setEditData({ ...editData, admin_fee_price: e.target.value });
                validate("admin_fee_price", e.target.value);
              }}
            />
          </Grid>
        </Grid>
        <Divider style={{ paddingTop: "8px", paddingBottom: "4px" }}>
          <Chip label="Image Details" />
        </Divider>
        <Grid container spacing={2}>
          <Grid item xs={4} sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", mt: 1 }} style={{ display: imageHardwareLoaded ? "block" : "none" }}>
            {rowData.product_image && (
              <>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <img src={process.env.REACT_APP_WEBSITE_BACKEND_URL + `${rowData.product_image}`} alt="Unkown" style={{ display: imageHardwareLoaded ? "block" : "none", maxWidth: "250px", height: "auto" }} onLoad={handleImageHardwareLoad} />
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <Button variant="contained" color="error" onClick={handleRemoveImageHardwareClick} sx={{ mt: 1 }} style={{ display: imageHardwareLoaded ? "block" : "none" }}>
                    Remove Hardware Image
                  </Button>
                </div>
              </>
            )}
          </Grid>
          <Grid item xs={4} sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", mt: 1 }} style={{ display: imageCashDrawerLoaded ? "block" : "none" }}>
            {rowData.cash_drawer_image && (
              <>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <img src={process.env.REACT_APP_WEBSITE_BACKEND_URL + `${rowData.cash_drawer_image}`} alt="Unkown" style={{ display: imageCashDrawerLoaded ? "block" : "none", maxWidth: "250px", height: "auto" }} onLoad={handleImageCashDrawerLoad} />
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <Button variant="contained" color="error" onClick={handleRemoveImageCashDrawerClick} sx={{ mt: 1 }} style={{ display: imageCashDrawerLoaded ? "block" : "none" }}>
                    Remove Cash Drawer Image
                  </Button>
                </div>
              </>
            )}
          </Grid>
          <Grid item xs={4} sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", mt: 1 }} style={{ display: imageReceiptPrinterLoaded ? "block" : "none" }}>
            {rowData.receipt_printer_image && (
              <>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <img src={process.env.REACT_APP_WEBSITE_BACKEND_URL + `${rowData.receipt_printer_image}`} alt="Unkown" style={{ display: imageReceiptPrinterLoaded ? "block" : "none", maxWidth: "250px", height: "auto" }} onLoad={handleImageReceiptPrinterLoad} />
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <Button variant="contained" color="error" onClick={handleRemoveImageReceiptPrinterClick} sx={{ mt: 1 }} style={{ display: imageReceiptPrinterLoaded ? "block" : "none" }}>
                    Remove Receipt Printer Image
                  </Button>
                </div>
              </>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ pt: 2.2 }}>
          <Grid item xs={4}>
            <TextField
              id="product_image"
              label="Upload New Hardware Image"
              type="file"
              margin="dense"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                accept: "image/*",
              }}
              onChange={(event) =>
                setEditData({
                  ...editData,
                  product_image: event.target.files && event.target.files[0] ? event.target.files[0] : "",
                })
              }
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="cash_drawer_image"
              label="Upload New Cash Drawer Image"
              type="file"
              margin="dense"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                accept: "image/*",
              }}
              onChange={(event) =>
                setEditData({
                  ...editData,
                  cash_drawer_image: event.target.files && event.target.files[0] ? event.target.files[0] : "",
                })
              }
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="receipt_printer_image"
              label="Upload New Receipt Printer Image"
              type="file"
              margin="dense"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                accept: "image/*",
              }}
              onChange={(event) =>
                setEditData({
                  ...editData,
                  receipt_printer_image: event.target.files && event.target.files[0] ? event.target.files[0] : "",
                })
              }
            />
          </Grid>
        </Grid>
        <Divider style={{ paddingTop: "8px", paddingBottom: "4px" }}>
          <Chip label="Description Details" />
        </Divider>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="product_description"
              label="Hardware"
              fullWidth
              multiline
              rows={6}
              defaultValue={rowData.product_description}
              error={errors.product_description}
              helperText={helperText.product_description}
              onChange={(e) => {
                setEditData({ ...editData, product_description: e.target.value });
                validate("product_description", e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="cash_drawer_description"
              label="Cash Drawer"
              fullWidth
              multiline
              rows={6}
              defaultValue={rowData.cash_drawer_description}
              error={errors.cash_drawer_description}
              helperText={helperText.cash_drawer_description}
              onChange={(e) => {
                setEditData({ ...editData, cash_drawer_description: e.target.value });
                validate("cash_drawer_description", e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="receipt_printer_description"
              label="Receipt Printer"
              fullWidth
              multiline
              rows={6}
              defaultValue={rowData.receipt_printer_description}
              error={errors.receipt_printer_description}
              helperText={helperText.receipt_printer_description}
              onChange={(e) => {
                setEditData({ ...editData, receipt_printer_description: e.target.value });
                validate("receipt_printer_description", e.target.value);
              }}
            />
          </Grid>
        </Grid>
        <Divider style={{ paddingTop: "8px", paddingBottom: "4px" }}>
          <Chip label="Additional Details" />
        </Divider>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="country_id"
              select
              label="Manage By"
              type="number"
              fullWidth
              required
              defaultValue={rowData.country_id}
              error={errors.country_id}
              helperText={helperText.country_id}
              onChange={(e) => {
                setEditData({ ...editData, country_id: e.target.value });
                validate("country_id", e.target.value);
              }}
            >
              {Countries.map((country) => (
                <MenuItem key={country.id} value={country.id}>
                  {country.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="order_no"
              label="Order No"
              type="number"
              fullWidth
              required
              defaultValue={rowData.order_no}
              error={errors.order_no}
              helperText={helperText.order_no}
              onChange={(e) => {
                setEditData({ ...editData, order_no: e.target.value });
                validate("order_no", e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              autoComplete="off"
              margin="dense"
              id="is_active"
              select
              label="Is Active"
              type="number"
              fullWidth
              required
              defaultValue={rowData.is_active}
              error={errors.is_active}
              helperText={helperText.is_active}
              onChange={(e) => {
                setEditData({ ...editData, is_active: e.target.value });
                validate("is_active", e.target.value);
              }}
            >
              {ProductStatus.map((status) => (
                <MenuItem key={status.id} value={status.id}>
                  {status.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ margin: "12px" }}>
        <Button onClick={handleEditProduct} variant="contained" color="primary" style={{ marginRight: "6px", color: "white" }}>
          Update
        </Button>
        <Button onClick={handleClose} variant="contained" color="error" style={{ marginRight: "6px", color: "white" }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
